module.exports = __webpack_public_path__ + "images/c14d3c7530f83635005567e258734735-LoginBrandImg.jpg";